import React from "react";
import IconComponent from "../Icons/IconComponent";

const RatingPilot = ({ starsColored = 0, isHighest }) => {
    return (
        <div className="bloc-stars" style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
            {Array.from({ length: 5 }, (_, i) => {
                const color = i < starsColored
                    ? isHighest
                        ? "primary-base"
                        : "carbone"
                    : isHighest
                        ? "primary-medium"
                        : "grey-light";

                return (
                    <IconComponent
                        key={i}
                        nameIcon="star"
                        color={color}
                        fill={true}
                        dimensions="16"
                    />
                );
            })}
        </div>
    );
};

export default RatingPilot;
